import React from 'react';
import { IForm } from '../../types/@types/generated/contentful';
import FormLayout from '../component-library/layout/FormLayout';
import SectionBackground from '../component-library/SectionBackground';
import { PageSectionComponent } from './pageSections';
import RichText from './RichText/RichText';

const FormSection: PageSectionComponent<null> = ({
  section: { fields: { title, description, references, settings, identifier } = {} } = {},
}) => {
  return (
    <SectionBackground id={settings?.id} backgroundColor={settings?.backgroundColor}>
      <FormLayout
        title={title && <RichText document={title} />}
        description={description && <RichText document={description} />}
        form={
          (references?.find(
            (reference) => reference.sys.contentType.sys.id === 'form',
          ) as unknown) as IForm
        }
        settings={{ identifier: settings?.pageName || identifier }}
      />
    </SectionBackground>
  );
};

export default FormSection;
